(function () {
  'use strict';

  var METHOD_TO_KIT = {
    'finger-prick': 'finger-prick',
    'nurse': 'venous',
    'partner-clinic': 'venous',
    'self-arrange': 'venous',
    'clinic': null
  };
  // Kit photos are ordinary product media (assigned in bulk by the API). A slide is matched by the alt text
  // of its image: "capillary" or "finger-prick" for the finger-prick kit, "venous" for the venous kit.
  var KIT_ALT = { 'finger-prick': /capillary|finger[- ]?prick/i, 'venous': /venous/i };
  // Hidden route slides are never rendered (gallery gate in media-gallery.liquid), so mainKitSlide simply finds nothing and focusKit returns.

  function productRoot(node) {
    if (node && node.closest) {
      var closest = node.closest('[id^="MainProduct-"]');
      if (closest) return closest;
    }
    return document.querySelector('[id^="MainProduct-"]');
  }

  function mainKitSlide(root, kind) {
    if (!root || !KIT_ALT[kind]) return null;
    var imgs = root.querySelectorAll('media-gallery .swiper-wrapper-preview img[alt], media-gallery .media-gallery__image img[alt], media-gallery img[alt]');
    for (var i = 0; i < imgs.length; i++) {
      if (KIT_ALT[kind].test(imgs[i].getAttribute('alt') || '')) {
        return imgs[i].closest('.swiper-slide') || imgs[i].closest('.media-gallery__image') || imgs[i].parentElement;
      }
    }
    return null;
  }

  function clearFocus(root) {
    if (!root) return;
    root.querySelectorAll('.is-clinilabs-kit-focus').forEach(function (node) {
      node.classList.remove('is-clinilabs-kit-focus');
    });
  }

  function focusKit(method, source, userInitiated) {
    var kind = METHOD_TO_KIT[method];
    var root = productRoot(source);
    if (!kind) { clearFocus(root); return; }

    var gallery = root && root.querySelector('media-gallery');
    var slide = mainKitSlide(root, kind);
    if (!gallery || !slide) return;

    clearFocus(root);
    slide.classList.add('is-clinilabs-kit-focus');
    var layout = gallery.dataset.layout;
    if (layout === 'thumbnail') {
      var controller = gallery.querySelector('slide-with-thumbs');
      var wrapper = gallery.querySelector('.swiper-wrapper-preview .swiper-wrapper');
      if (!controller || !wrapper) return;
      var slides = Array.prototype.slice.call(wrapper.children);
      var index = slides.indexOf(slide);
      if (index < 0) return;
      if (typeof controller.functionGoto === 'function' && controller.globalSlide) {
        controller.functionGoto(index);
      } else if (userInitiated && slide.scrollIntoView) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    if (userInitiated && slide.scrollIntoView) {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function checkedMethod(root) {
    if (!root) return null;
    return root.querySelector('input[name="sample_collection"]:checked');
  }

  function initialiseRoot(root) {
    var selected = checkedMethod(root);
    if (selected) focusKit(selected.value, selected, false);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches('input[name="sample_collection"]')) return;
    focusKit(target.value, target, true);
  });

  function initialiseAll() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(initialiseRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll();
      window.setTimeout(initialiseAll, 500);
      window.setTimeout(initialiseAll, 1400);
    });
  } else {
    initialiseAll();
    window.setTimeout(initialiseAll, 500);
    window.setTimeout(initialiseAll, 1400);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseRoot(productRoot(event.target));
  });
})();

